// Assets
// import React, {useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
// lazy route
import React, { lazy, useEffect, useState } from "react";

// Component
// import Rough from "../rough/rough";
import Home from "../pages/home/home";
import HomeScreen from "../AppHomeScreen";
// import HomeSlidev1 from "../pages/home/sliderv1";

// Test Component
import Login from "../components/login";
// import SSOLogin from "../components/ssologin";
// import Teststripe from "../components/simplecard";
// import Applepay from "../components/apple";
// import MyuseApp from "../components/useCtest";
import Gpay from "../components/PaymentForm";

// My Account
// import Myaccount from "../pages/myaccount/myaccount-layout";
// import Profile from "../pages/myaccount/components/profile/profile";
// import OrderStatus from "../pages/myaccount/components/orderstatus/orderstatus";
// import WalletTC from "../pages/myaccount/components/wallet-tc/wallet-tc";
// import WalletPage from "../pages/myaccount/components/wallet/wallet";
// import SavedCards from "../pages/myaccount/components/wallet/savedcard";
// import AddCard from "../pages/myaccount/components/wallet/addcard";
// import WalletHistory from "../pages/myaccount/components/wallet/history";
// import AddressBook from "../pages/myaccount/components/addressbook/addressbook";
// import MyOrder from "../pages/myaccount/components/myorder/myorder";
// import OrderDetailPage from "../pages/myaccount/components/myorder/orderdetail";
// import StuartTrack from "../pages/myaccount/components/orderstatus/components/stuart-track";
// import Cookies from "../pages/cookies/cookies";

// Restaurant list
import ListPage from "../pages/listpage/listpage";
// import TermsCondition from "../pages/terms-condition/terms-condition";
// import Partners from "../pages/partners-terms/partners-terms";
// import Brand from "../pages/our-brand/our-brand";
import Stuart from "../pages/stuartT&C/stuart";
// import Faq from "../pages/faq/faq";
// import Allergy from "../pages/allergy/allergy";
// import MenuPage from "../pages/menu/menu-page";
// import AllMenu from "../pages/menu/menu";
// import MenuAbout from "../pages/menu/about";
// import MenuReview from "../pages/menu/review";
// import Rateus from "../pages/rate-us/rate-us";
// import Refund from "../pages/refund-expired/refund";
// import Contactless from "../pages/contactless-dining/contactless";
import Cardrefund from "../pages/card-refund/card-refund";
// import Policyprivacy from "../pages/policy-privacy/policy";
// import Aboutus from "../pages/aboutus/aboutus";
// import Career from "../pages/career/career";
import Errorpage from "../pages/errorpage/errorpage";
// import Becomepartner from "../pages/become-partner/becomepartner";
// import Help from "../pages/help/help";
import WithOrder from "../pages/help/with-order";
import OfferInfo from "../pages/help/offer-information";
import GuideFusion from "../pages/help/guid-fusion";
import AccountOptions from "../pages/help/account-options";
import Leadsignup from "../pages/leadsignup/leadsignup";
import CheckoutPage from "../pages/checkout/checkout";
import CheckoutV2 from "../pages/checkout/checkoutV2";
import Checkoutpageskele from "../pages/checkout/Checkoutpageskeleton";

// import AllCuisines from "../pages/all-cuisines/all-cuisines";
// import AllArea from "../pages/all-area/allarea";
// import Reseller from "../pages/reseller/reseller";
import BlogDetail from "../pages/blogdetails/blogdetails";
// import Blog from "../pages/blog/blog";
import Rateus from "../pages/rate-us/rate-us";
import Refund from "../pages/refund-expired/refund";

import Loadable from "./loadable";
import { getSeoDataApi } from "../../src/api/seo/seo";
import Sitemap from "../pages/seo/sitemap";
import FeedbackForm from "../pages/myaccount/components/Feedbackacc/feedbackv2";
import UserProfile from "../pages/myaccount/components/profile/profile";
import Ratingmyaccount from "../pages/myaccount/components/rating/rating";
import MoneyPage from "../pages/myaccount/components/wallet/wallet";
// import Selectlanguage from "../pages/myaccount/components/language/language";
// import Paymentsettings from "../pages/myaccount/components/Paymentsetting/paymentmyaccount";
// import Addressmyaccount from "../pages/myaccount/components/addressbook/addressbookV2";
// import Fusionwallet from "../pages/myaccount/components/walletmyaccount/walletmyacc";
import Favouriteorder from "../pages/myaccount/components/favouriteorder/favouriteorder";
// import Settingsfusion from "../pages/myaccount/components/settings/settingsfk";
import Yourorder from "../pages/myaccount/components/myorder/myorder";
import Tablebooking from "../pages/myaccount/components/Tablebooking/tablebooking";
// import Addcardv3 from "../pages/myaccount/components/wallet/addcardv3";

// const HomeSlidev1 = lazy(() => import("../pages/home/sliderv1"));
// const Checkoutv2 = lazy(() => import("../pages/checkout/checkoutV2"));
//top bar Lazy
const Becomepartner = Loadable(
  lazy(() => import("../pages/become-partner/becomepartner"))
);
const Help = Loadable(lazy(() => import("../pages/help/help")));
//footer lazy
const Faq = Loadable(lazy(() => import("../pages/faq/faq")));
const Blog = Loadable(lazy(() => import("../pages/blog/blog")));
const TermsCondition = Loadable(
  lazy(() => import("../pages/terms-condition/terms-condition"))
);
const Partners = Loadable(
  lazy(() => import("../pages/partners-terms/partners-terms"))
);
const CustomerAgreement = Loadable(lazy(() => import("../pages/customer-agrement/CustomerAgreement")))
const AllArea = Loadable(lazy(() => import("../pages/all-area/allarea")));
const AllCuisines = Loadable(
  lazy(() => import("../pages/all-cuisines/all-cuisines"))
);
const Brand = Loadable(lazy(() => import("../pages/our-brand/our-brand")));
const Reseller = Loadable(lazy(() => import("../pages/reseller/reseller")));
const Contactless = Loadable(
  lazy(() => import("../pages/contactless-dining/contactless"))
);
const Aboutus = Loadable(lazy(() => import("../pages/aboutus/aboutus")));
const Career = Loadable(lazy(() => import("../pages/career/career")));
const Allergy = Loadable(lazy(() => import("../pages/allergy/allergy")));
const Policyprivacy = Loadable(
  lazy(() => import("../pages/policy-privacy/policy"))
);

// Myaccount Lazy
const Myaccount = Loadable(
  lazy(() => import("../pages/myaccount/myaccount-layout"))
);
const Profile = Loadable(
  lazy(() => import("../pages/myaccount/components/profile/profile"))
);
const OrderStatus = Loadable(
  lazy(() => import("../pages/myaccount/components/orderstatus/orderstatus"))
);

const Orderstatusskle = Loadable(
  lazy(() =>
    import("../pages/myaccount/components/orderstatus/Orderstatusskle")
  )
);
const WalletTC = Loadable(
  lazy(() => import("../pages/myaccount/components/wallet-tc/wallet-tc"))
);
const WalletPage = Loadable(
  lazy(() => import("../pages/myaccount/components/wallet/wallet"))
);
const SavedCards = Loadable(
  lazy(() => import("../pages/myaccount/components/wallet/savedcard"))
);
// const AddCard = Loadable(
//   lazy(() => import("../pages/myaccount/components/wallet/addcard"))
// );
const WalletHistory = Loadable(
  lazy(() => import("../pages/myaccount/components/wallet/history"))
);
const AddressBook = Loadable(
  lazy(() => import("../pages/myaccount/components/addressbook/addressbook"))
);
const MyOrder = Loadable(
  lazy(() => import("../pages/myaccount/components/myorder/myorder"))
);
const OrderDetailPage = Loadable(
  lazy(() => import("../pages/myaccount/components/myorder/orderdetail"))
);
const StuartTrack = Loadable(
  lazy(() =>
    import("../pages/myaccount/components/orderstatus/components/stuart-track")
  )
);
const Cookies = Loadable(lazy(() => import("../pages/cookies/cookies")));

//menuPage Lazy
const MenuPage = Loadable(lazy(() => import("../pages/menu/menu-page")));
const Fkfruitsliderv3 = Loadable(
  lazy(() => import("../pages/menu/fkfruitsliderv3"))
);
const Menupagev3 = Loadable(lazy(() => import("../pages/menu/menu-pagev3")));
const Bestsellerv3 = Loadable(lazy(() => import("../pages/menu/bestsellerv3")));
const AllMenu = Loadable(lazy(() => import("../pages/menu/menu")));
const MenuV3 = Loadable(lazy(() => import("../pages/menu/menuv3")));
const MenuAbout = Loadable(lazy(() => import("../pages/menu/about")));
const MenuReview = Loadable(lazy(() => import("../pages/menu/review")));
const MenuPageShopping = Loadable(
  lazy(() => import("../pages/menu/menuShopingPage"))
);
const MenuProductDetail = Loadable(
  lazy(() => import("../pages/menu/menuDetail"))
);
// import AllMenu from "../pages/menu/menu";
// import MenuAbout from "../pages/menu/about";
// import MenuReview from "../pages/menu/review";

const Routing = (params) => {
  const [analyticCode, setAnalyticCode] = useState(); // Initialize sitemap state to null
  const loginCheck1 = localStorage.getItem("isLoggedIn");
  const loginCheck = loginCheck1 === "true";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = {
          domain: window.location.hostname,
        };
        const apiResponse = await getSeoDataApi(formData);
        if (apiResponse?.data?.status === false) {
          // Handle error condition
          console.error(
            "Error fetching sitemap data:",
            apiResponse.data.message
          );
        } else {
          // Handle success condition
          setAnalyticCode(apiResponse.data.message.analytic_code); // Update sitemap state with the fetched data
        }
      } catch (error) {
        console.error("Error fetching sitemap data:", error);
      }
    };

    fetchData(); // Call fetchData when the component mounts
  }, []); // Empty dependency array to ensure this effect runs only once

  const location = useLocation();
  // useEffect(() => {
  //   if (analyticCode) {
  //     const TRACKING_ID = analyticCode;
  //     ReactGA.initialize(TRACKING_ID);
  //     ReactGA.pageview(window.location.pathname + window.location.search);
  //   }
  // }, [analyticCode, location]);

  useEffect(() => {
    if (analyticCode) {
      // Add the Google Analytics script to the document head
      const script = document.createElement("script");
      script.async = true;
      script.src =
        `https://www.googletagmanager.com/gtag/js?id=` + analyticCode;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", analyticCode);

      // Track page views
      gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });

      // Cleanup function to remove the script
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [analyticCode, location]);

  const RoutingPaths = [
    { url: "/", element: <Home /> },
    {
      url: "/app",
      element: loginCheck ? <Home /> : <HomeScreen />,
    },
    { url: "*", element: <Errorpage /> },
    // { url: "/sliderv1", element: <HomeSlidev1 /> },
    { url: "/login", element: <Login /> },
    // { url: "/teststripe", element: <Teststripe /> },
    // { url: "/testusec", element: <MyuseApp /> },
    { url: "/gpay", element: <Gpay /> },
    { url: "/list", element: <ListPage /> },
    { url: "/general-terms", element: <TermsCondition /> },
    { url: "/partner-terms", element: <Partners /> },
    { url: "/customer-agreement", element: <CustomerAgreement /> },
    { url: "/our-brand", element: <Brand /> },
    { url: "/stuart-delivery", element: <Stuart /> },
    { url: "/faq", element: <Faq /> },
    { url: "/allergy", element: <Allergy /> },
    { url: "/cookies", element: <Cookies /> },
    { url: "/refundlinkexpired", element: <Refund /> },
    { url: "/contactlessdinning", element: <Contactless /> },
    { url: "/cardrefund", element: <Cardrefund /> },
    { url: "/privacy", element: <Policyprivacy /> },
    { url: "/about", element: <Aboutus /> },
    { url: "/career", element: <Career /> },
    { url: "/partner", element: <Becomepartner /> },
    { url: "/help", element: <Help /> },
    { url: "/help-with-order", element: <WithOrder /> },
    { url: "/offer-information", element: <OfferInfo /> },
    { url: "/guide-fusion", element: <GuideFusion /> },
    { url: "/account-options", element: <AccountOptions /> },
    { url: "/signup", element: <Leadsignup /> },
    { url: "/area", element: <AllArea /> },
    { url: "/cuisines", element: <AllCuisines /> },
    { url: "/reseller", element: <Reseller /> },
    { url: "/blog", element: <Blog /> },
    { url: "/sitemap.xml", element: <Sitemap /> },
  ];
  const MyAccountRouts = [
    {
      moblink: true,
      url: "/myaccount",
      element: <Myaccount />,
      subpaths: [
        {
          url: "profile",
          element: <UserProfile />,
        },
        {
          url: "orderstatus",
          element: <OrderStatus />,
        },

        {
          url: "Orderstatusskle",
          element: <Orderstatusskle />,
        },
        {
          url: "wallet-tc",
          element: <WalletTC />,
        },
        {
          url: "wallet",
          element: <WalletPage />,
        },
        {
          url: "savedcards",
          element: <SavedCards />,
        },
        // {
        //   url: "addcardV3",
        //   element: <Addcardv3/>,
        // },
        {
          url: "wallethistory",
          element: <WalletHistory />,
        },
        {
          url: "addressbook",
          element: <AddressBook />,
        },
        {
          url: "myorder",
          element: <MyOrder />,
        },
        {
          url: "orderdetail",
          element: <OrderDetailPage />,
        },
        {
          url: "stuarttrack",
          element: <StuartTrack />,
        },
        {
          url: "feedbackmyaccount",
          element: <FeedbackForm />,
        },
        {
          url: "profileorder",
          element: <UserProfile />,
        },
        {
          url: "rating",
          element: <Ratingmyaccount />,
        },
        {
          url: "moneypage",
          element: <MoneyPage />,
        },
        // {
        //   url: "language",
        //   element: <Selectlanguage />,
        // },
        // {
        //   url: "paymentsetting",
        //   element: <Paymentsettings />,
        // },
        // {
        //   url: "addressaccount",
        //   element: <Addressmyaccount />,
        // },
        // {
        //   url: "walletpage",
        //   element: <Fusionwallet/>,
        // },
        {
          url: "favouriteorder",
          element: <Favouriteorder/>,
        },
        // {
        //   url: "settingsfk",
        //   element: <Settingsfusion/>,
        // },
        {
          url: "yourorder",
          element: <Yourorder/>,
        },
        {
          url: "help",
          element: <Help/>,
        },
        {
          url: "tablebooking",
          element: <Tablebooking/>,
        },
      ],
    },
  ];
  return (
    <>
      <>
        <Routes>
          {RoutingPaths.map((RoutingPath, index) => (
            <Route
              key={index}
              exact
              path={RoutingPath.url}
              orderId={RoutingPath.orderId}
              element={RoutingPath.element}
            />
          ))}
          <Route path="/:path" element={<MenuPage />}>
            <Route index element={<AllMenu />} />
           
            <Route path="menu" element={<AllMenu />} />
            <Route path="menupagev3" element={<Menupagev3 />} />
            <Route path="menuv3" element={<MenuV3 />} />
            <Route path="review" element={<MenuReview />} />
            <Route path="about" element={<MenuAbout />} />
          </Route>
          <Route path="/:path/newcheckout" element={<CheckoutV2 />}></Route>
          <Route path="/:path/product/:id" element={<MenuProductDetail />} />
          <Route path="/:path/shopping" element={<MenuPageShopping />} />
          <Route path="/:path/rateus/:orderId" element={<Rateus />}></Route>
          <Route path="/:path/checkout" element={<CheckoutV2 />}></Route>
          <Route
            path="/:path/Checkoutpageskeleton"
            element={<Checkoutpageskele />}
          ></Route>

          <Route path="/blog/:path" element={<BlogDetail />} />
          {/* MY Account */}
          {/* My Account Desktop URL */}
          {MyAccountRouts?.map((MyAccountRout, index) => (
            <>
              <Route
                key={index}
                path={MyAccountRout.url}
                element={MyAccountRout.element}
              >
                <Route index element={<UserProfile />} />
                {MyAccountRout.subpaths.map((subpath, index) => (
                  <>
                    <Route
                      key={index}
                      path={subpath.url}
                      element={subpath.element}
                    />
                  </>
                ))}
              </Route>
            </>
          ))}
          {/* My Account Mobile URL */}
          {MyAccountRouts[0].subpaths.map((subpath, index) => (
            <Route
              key={index}
              path={"/" + subpath.url}
              element={subpath.element}
            />
          ))}
        </Routes>
      </>
    </>
  );
};
export default Routing;
